import {Theme} from '@mui/material';
import {ChipColorEnum, TagChipProps, VariantType} from './types';

const tagChipOptions = (theme: Theme, color: VariantType): TagChipProps['bgColor'] => {
	const styles = {
		[ChipColorEnum.DEFAULT]: undefined,
		[ChipColorEnum.PRIMARY]: theme.colors.light.primary['12Percent'],
		[ChipColorEnum.SECONDARY]: theme.colors.light.secondary['30Percent'],
		[ChipColorEnum.INFO]: theme.colors.light.info['30Percent'],
		[ChipColorEnum.SUCCESS]: theme.colors.light.success['30Percent'],
		[ChipColorEnum.ERROR]: theme.colors.light.error['30Percent'],
		[ChipColorEnum.WARNING]: theme.colors.light.warning['30Percent'],
	};

	return styles[color];
};

export {tagChipOptions};
